export default __webpack_public_path__ + "static/media/eCConductivity.d3dafed8.svg";